import { filter, map, mergeMap } from 'rxjs/operators'
import * as ReduxObservable from 'redux-observable'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Router from '../../router'
import * as App from '../../app'
import { of, EMPTY } from 'rxjs'
import queryString from 'query-string'

// Epic to handle route navigation
export const onEnterEpic: ReduxObservable.Epic = (action$, state$, { history }: any) =>
  action$.ofType(Router.ON_ENTER).pipe(
    filter((action: any) => history.location.pathname.startsWith(Constants.URL_HOME)),
    map(({ params }: any) => {
      const token = queryString.parse(history.location.search).token as string;
      
      if (token && params.community_identifier) {
        // Store URL params and fetch both user topics and suggested topics
        return of(
          { type: Constants.INITIALIZE_FROM_URL, query: { token, community_identifier: params.community_identifier } },
          Request.requestActionCreator<Request.RequestOptions>(Constants.FETCH_USER_TOPICS)({
            method: 'GET',
            public: true,
            url: `/topic_preference/my_topics/${params.community_identifier}/${token}`,
          }),
          Request.requestActionCreator<Request.RequestOptions>(Constants.FETCH_SUGGESTED_TOPICS)({
            method: 'GET',
            public: true,
            url: `/topic_preference/suggest_topics/${params.community_identifier}/${token}`,
          })
        );
      }
      
      return EMPTY;
    }),
    mergeMap(actions => actions)
  );

// Mark the page as ready for rendering
export const readyForRenderEpic: ReduxObservable.Epic = (action$) =>
  action$.ofType(
    Request.successConstant(Constants.FETCH_USER_TOPICS),
    Request.errorConstant(Constants.FETCH_USER_TOPICS),
    Request.successConstant(Constants.FETCH_SUGGESTED_TOPICS),
    Request.errorConstant(Constants.FETCH_SUGGESTED_TOPICS)
  ).pipe(
    map(() => App.readyForRender())
  );

// Handle successful submission
export const onSuccessfulSubmissionEpic: ReduxObservable.Epic = (action$, store, { history }) =>
  action$.ofType(Request.successConstant(Constants.SUBMIT_TOPIC_PREFERENCES))
    .pipe(
      map(() => Router.push(history.location.pathname))
    );

export const epic = ReduxObservable.combineEpics(
  onEnterEpic,
  readyForRenderEpic,
  onSuccessfulSubmissionEpic
)